<template>
	<div>
		<HeaderBreadcrumbs
			:items="[
				{
					label: 'Announcement',
					to: { name: AnnouncementManagePath.name }
				},
				{
					label: 'Add New'
				}
			]"
			title="New Announcement"
		/>
	<div class=" bg-white rounded-lg p-4 shadow-md my-3" >
		<div class="flex-col w-1/3 mt-3 pr-4">
		<label class="text-gray-600 text-sm font-semibold mb-3 block">Title</label>
        <input
          v-model="form.title"
          id="announcement-title"
          placeholder="e.g.: Maintenance Server"
          type="text"
	maxlength="50"
	required
          class="bg-gray-50 py-2.5 px-2 border rounded-lg w-full"
        />
		<label class="text-gray-600 text-sm font-semibold my-3 mb-3 block">Message</label>
		<div class="relative">
			<textarea
          v-model="form.message"
          id="announcement-description"
          placeholder="Write text here ..."
          rows="4"
	maxlength="200"
          class="bg-gray-50 py-2.5 px-2 border rounded-lg w-full"
        ></textarea>
		<div class="text-right text-xs mt-1 text-gray-500">
			{{ form.message?.length }}/200
		</div>
		</div>
		<DatetimeCustom :timeDate="true" class="mt-3 w-full" :label="'Start date'" v-model="form.valid_from"></DatetimeCustom>
		<DatetimeCustom :timeDate="true" class="mt-3 w-full" :label="'End date'" v-model="form.valid_to"></DatetimeCustom>
		<label class="text-gray-600 text-sm font-semibold my-3 mb-3 block">Status</label>
		<div>
              <button type="button" @click="toggleActive" :class="{
                  'bg-blue-700': form.is_active,
                  'bg-gray-300': !form.is_active
                }" class="w-12 h-6 button-active-inactive rounded-full relative transition-colors duration-200 focus:outline-none">
                              <span :class="{
                  'translate-x-6': form.is_active,
                  'translate-x-0': !form.is_active
                }" class="w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200"></span>
              </button>
            </div>

	</div>
	<div class="flex">
		<button class="bg-blue-700 py-2 px-3 mt-3 rounded-lg text-white" type="submit" @click="onSubmit">Save</button>
		<button class="bg-white py-2 px-3 mt-3 rounded-lg text-gray-900 border ml-3">
			<router-link class="text-gray-900 hover:no-underline hover:text-gray-900" :to="{name: AnnouncementManagePath.name}">
					Cancel
				</router-link>
		</button>
	</div>
	</div>
	</div>

</template>

<script>
import { mapState, mapActions } from "vuex";
import { AnnouncementManagePath } from "../../router/announcements";
import DatetimeCustom from '../../components/form/Datetime.vue'
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue'
import { EventBus } from '../../../src/event-bus'
import moment from "moment";
export default {
	name: "new-announcement",
	components: {
        DatetimeCustom,
				HeaderBreadcrumbs
    },
	data() {
		return {
			debounce: null,
			AnnouncementManagePath,
			form: {
				title: null,
				message: '',
				publisher: null,
				valid_from: moment().toString(),
				valid_to: moment().toString(),
				is_active: false
			},
			isPublisherSearch: false,
			publisherSearchOptions: [],
		};
	},
	computed: {
		...mapState({
			isError: (state) => state.announcement.isError,
			isLoading: (state) => state.announcement.isLoading,
			errorMessage: (state) => state.announcement.errorMessage,
			successMessage: (state) => state.announcement.successMessage,
			item: (state) => state.announcement.item
		})
	},
	watch: {
		errorMessage: function() {
			if (!this.errorMessage) return;
			//this.messageAlert("error", this.errorMessage, 5000);
			EventBus.$emit('show-toast', {
				message: this.errorMessage,
				type: 'error',
			});
		},
		successMessage: function() {
			if (!this.successMessage) return;
			// this.messageAlert("success", this.successMessage);
			EventBus.$emit('show-toast', {
				message: 'New announcement has been added.',
				type: 'error',
			});
			Object.assign(this.$data, this.$options.data.call(this));
			this.$router.push(AnnouncementManagePath);
		}
	},
	created() {},
	methods: {
		...mapActions("announcement", ["postAnnouncements"]),
		...mapActions("vendors", ["AutocompleteSearch"]),

		onSubmit(event) {
			event.preventDefault();
			const data = this.form;

			const payload = {
				title: data.title,
				message: data.message,
				valid_from: (() => {
				const date = new Date(data.valid_from);
				return date.toISOString();
				})(),
				valid_to: (() => {
					const date = new Date(data.valid_to);
					return date.toISOString();
				})(),
				is_active: data.is_active ? true : false,
			};
			this.postAnnouncements(payload);
		},

		formatToISOString (date)
		{return date.toISOString()
		},
		onReset() {},
		publisherFind(query) {
			if (!query) return;

			this.isPublisherSearch = true;
			clearTimeout(this.debounce);
			this.debounce = setTimeout(() => {
				this.AutocompleteSearch({ q: query })
					.then((response) => {
						this.publisherSearchOptions = response.data.data.rows;
						this.isPublisherSearch = false;
					})
					.catch(() => {
						this.isPublisherSearch = false;
					});
			}, 1200);
		},
		toggleActive() {
      this.form.is_active = !this.form.is_active;
    },
		messageAlert(icon, title, timer = 3000) {
			this.$swal({
				toast: "true",
				position: "top-end",
				icon,
				title,
				showConfirmButton: false,
				timer,
				timerProgressBar: true,
			});
		},
	},
};
</script>
<style>
.button-active-inactive {
  position: relative;
  display: inline-flex;
  align-items: center;
}
</style>
